/*** 获取文本px宽度* @param font{String}: 字体样式**/
String.prototype.pxWidth = function (font) {
    var canvas = String.prototype.pxWidth.canvas || (String.prototype.pxWidth.canvas = document.createElement("canvas")),
        context = canvas.getContext("2d");

    font && (context.font = font);
    var metrics = context.measureText(this);

    return metrics.width;
}